import { render, staticRenderFns } from "./CreatePricelist.vue?vue&type=template&id=28d0089e"
import script from "./CreatePricelist.vue?vue&type=script&lang=js"
export * from "./CreatePricelist.vue?vue&type=script&lang=js"
import style0 from "./CreatePricelist.vue?vue&type=style&index=0&id=28d0089e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports